const rootUrl = 'https://shoopifai-api.herokuapp.com/api/v1/';
const loginUrl = rootUrl + 'users/login/';
const signupUrl = rootUrl + 'users/signup/';
const categoryUrl = rootUrl + 'category/';
const productsUrl = rootUrl + 'products/';
const collectionUrl = rootUrl + 'collection/';
const variantUrl = rootUrl + 'variant/';

const cloudinaryUrl = 'https://api.cloudinary.com/v1_1/dhlhf9zh2/';

export {
  rootUrl,
  loginUrl,
  signupUrl,
  categoryUrl,
  productsUrl,
  collectionUrl,
  cloudinaryUrl,
  variantUrl,
};
